import van from "/public/van.webp";
import "./Progress.css";

export const Progress = ({
  step,
  totalSteps,
}: {
  step: number;
  totalSteps: number;
}) => {
  const progressPercentage = ((step + 1) / totalSteps) * 100;

  return (
    <div className="Progress">
      <div className="ProgressBar" style={{ width: `${progressPercentage}%` }}>
        <img className="ProgressIcon" src={van} alt="" />
      </div>
      <div className="ProgressText">
        <p>{progressPercentage.toFixed(0)}%</p>
      </div>
    </div>
  );
};
